type FlatObject = Record<string, unknown>;
type NestedObject = Record<string, unknown>;

export function unflattenObject<T extends FlatObject>(obj: T): NestedObject {
    const result: NestedObject = {};

    for (const [key, value] of Object.entries(obj)) {
        const keys = key.split(".");
        let current: NestedObject = result;

        keys.forEach((k, index) => {
            const isLast = index === keys.length - 1;

            if (isLast) {
                current[k] = value;
            } else {
                if (!(k in current) || typeof current[k] !== "object" || current[k] === null) {
                    current[k] = {};
                }
                current = current[k] as NestedObject;
            }
        });
    }

    return result;
}
